import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Features.css";
import img1 from "../metaverseassets/feature1.png";
import img2 from "../metaverseassets/feature2.png";
import img3 from "../metaverseassets/feature3.png";
import img4 from "../metaverseassets/feature4.png";

export default function Features() {
  const navigation = useNavigate();

  const cards = [
    {
      img: img1,
      title: "Scalable metaverse architecture",
      border: "1px solid #FFC0D9",
      color: "#FFC0D9",
      desc: "Design of flexible metaverse infrastructure that supports growing users, assets, and interactions without performance issues.",
    },
    {
      img: img2,
      title: "Avatar creation and customization:",
      border: "1px solid #D0BFFF",
      color: "#D0BFFF",
      desc: "Development of customizable avatars that allow users to express identity through appearance, assets, and interactive features.",
    },
    {
      img: img3,
      title: "Virtual spaces, events, and environments",
      border: "1px solid #B5F1CC",
      color: "#B5F1CC",
      desc: "Creation of immersive virtual worlds, event spaces, and environments designed for social interaction, collaboration, and engagement.",
    },
    {
      img: img4,
      title: "Cross-platform compatibility",
      border: "1px solid #9FE9F6",
      color: "#9FE9F6",
      desc: "Metaverse experiences optimized to run smoothly across web, mobile, and VR devices for consistent user access.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getCardsPerView = () => {
    if (windowWidth <= 640) return 1;
    if (windowWidth <= 768) return 2;
    return 2;
  };

  const cardsPerView = getCardsPerView();
  const maxIndex = cards.length - cardsPerView;

  const goToSlide = (index) => {
    setCurrentIndex(Math.min(index, maxIndex));
  };

  return (
    <div id="metaverse-feature" className="metaversemainclass">
      <div className="left">
        <h1 className="heading">
          Custom Metaverse Development for Scalable Virtual Experiences
        </h1>
        <p className="subheading">
          Custom metaverse development creates immersive virtual spaces aligned with business use cases, enabling seamless interaction, digital asset ownership, and future-ready scalability.
        </p>
        <button onClick={() => navigation("/contact_us")}
          style={{cursor:"pointer"}}>Let's Discuss Your Project</button>
      </div>
      <div className="right">
        <div className="cards">
          {cards.map((card, i) => (
            <div className="card" key={i} style={{ border: card.border }}>
              <img src={card.img} alt="" style={{ border: card.border }} />
              <h3 style={{ color: card.color }}>{card.title}</h3>
              <span>{card.desc}</span>
            </div>
          ))}
        </div>

        <div className="carousel-container">
          <div className="carousel-wrapper">
            <div
              className="carousel-track"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / cardsPerView)
                }%)`,
              }}
            >
              {cards.map((card, i) => (
                <div
                  className="carousel-card-wrapper"
                  key={i}
                  style={{ flex: `0 0 ${100 / cardsPerView}%` }}
                >
                  <div className="card" style={{ border: card.border }}>
                    <img
                      src={card.img}
                      alt=""
                      style={{ border: card.border }}
                    />
                    <h3 style={{ color: card.color }}>{card.title}</h3>
                    <span>{card.desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="carousel-dots">
            {Array.from({ length: maxIndex + 1 }).map((_, index) => (
              <button
                key={index}
                className={`dot ${currentIndex === index ? "active" : ""}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
